import Vue from 'vue'
import qs from 'qs'

export default {
  getAll (getActiveOnly = false, withRelationships = []) {
    withRelationships = Array.join(withRelationships)
    return Vue.http.get('/licensor/locations', {
      params: {
        getActiveOnly: getActiveOnly,
        withRelationships: withRelationships
      }
    })
  },

  get (id) {
    return Vue.http.get(`/licensor/locations/${id}`)
  },

  list (from, to, config = {}) {
    return Vue.http.get('/licensor/location_sales', {
      params: {
        from,
        to
      },
      ...config
    })
  },

  transactions (id, query) {
    return Vue.http.get(`/licensor/locations/${id}/transactions`, {
      params: query,
      paramsSerializer: qs.stringify
    })
  },

  getProducts (id, withCombos = false, withPromotion = false) {
    return Vue.http.get(`/licensor/locations/${id}/products`, {
      params: {
        with_combos: withCombos,
        with_promotion: withPromotion
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/licensor/location.js